import { gql } from "@apollo/client";
import { FC } from "react";

import { useToast } from "@src/lib/hooks/useToast";
import { GraphqlOperations } from "@src/types.generated";

import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import { useDeleteChatMutation } from "./DeleteChatDialog.generated";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  chatId: string;
  onDeleted?: () => void;
};

const DeleteChatDialog: FC<Props> = ({
  open,
  onOpenChange,
  chatId,
  onDeleted,
}) => {
  const { addToast, addErrorToast } = useToast();

  const [deleteChat, { loading }] = useDeleteChatMutation({
    variables: { input: { chatId } },
    refetchQueries: [GraphqlOperations.Query.NewMessagingChats],
    onError: (error) => {
      addErrorToast({ ...error, callsite: "delete_chat" });
    },
    onCompleted: (data) => {
      if (!data.deleteChat.success) {
        addErrorToast({ data, callsite: "delete_chat" });
        return;
      }
      addToast({ message: "Chat deleted" });
      onOpenChange(false);
      onDeleted?.();
    },
  });

  return (
    <ConfirmDeleteDialog
      title="Delete Chat"
      body="Deleting this chat removes the conversation and all of its messages for everyone."
      open={open}
      onOpenChange={onOpenChange}
      loading={loading}
      onConfirm={() => deleteChat()}
    />
  );
};

gql`
  mutation DeleteChat($input: DeleteChatInput!) {
    deleteChat(input: $input) {
      success
      error {
        code
      }
    }
  }
`;

export default DeleteChatDialog;
